import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AppStabilityService } from '../../shared/app-stability.service';

@Component({
  selector: 'qm-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent implements OnInit, OnDestroy {

  @Input()
  public mode: 'analog' | 'digital' = 'analog';

  public secAngle;
  public minAngle;
  public hourAngle;

  public lines = [];
  public date: Date = new Date();
  private timer: any;

  constructor(private appStability: AppStabilityService) {
  }

  ngOnInit() {
    console.log('CLock component init!');
    for (let i = 0; i < 60; i++) {
      this.lines.push(i);
    }
    this.appStability.whenFirstStable().then(() => {
      this.timer = setInterval(() => {
        this.tick();
      }, 100);
    });
  }

  ngOnDestroy(): void {
    if(this.timer) {
      clearInterval(this.timer);
    }
  }

  private tick() {
    this.date = new Date();
    const seconds = this.date.getSeconds();
    const minutes = this.date.getMinutes();
    const hours = this.date.getHours();

    this.secAngle = seconds * 6;
    this.minAngle = minutes * 6 + seconds * (360 / 3600);
    this.hourAngle = hours * 30 + minutes * (360 / 720);
  }

}
